/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBeds } from 'app/entities/bed/bed.reducer';
import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { BedAllotmentType } from 'app/shared/model/enumerations/bed-allotment-type.model';
import { BedReleaseType } from 'app/shared/model/enumerations/bed-release-type.model';
import { createEntity, getEntity, reset, updateEntity } from './bed-allotment.reducer';

export const BedAllotmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const beds = useAppSelector(state => state.bed.entities);
  const admissions = useAppSelector(state => state.admission.entities);
  const bedAllotmentEntity = useAppSelector(state => state.bedAllotment.entity);
  const loading = useAppSelector(state => state.bedAllotment.loading);
  const updating = useAppSelector(state => state.bedAllotment.updating);
  const updateSuccess = useAppSelector(state => state.bedAllotment.updateSuccess);
  const bedAllotmentTypeValues = Object.keys(BedAllotmentType);
  const bedReleaseTypeValues = Object.keys(BedReleaseType);

  const handleClose = () => {
    navigate(`/bed-allotment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBeds({}));
    dispatch(getAdmissions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.allotmentDate !== undefined && typeof values.allotmentDate !== 'number') {
      values.allotmentDate = Number(values.allotmentDate);
    }
    if (values.releaseDate !== undefined && typeof values.releaseDate !== 'number') {
      values.releaseDate = Number(values.releaseDate);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...bedAllotmentEntity,
      ...values,
      bed: beds.find(it => it.id.toString() === values.bed?.toString()),
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          allotmentType: 'TRANSFER_IN',
          releaseType: 'TRANSFER_OUT',
          ...bedAllotmentEntity,
          bed: bedAllotmentEntity?.bed?.id,
          admission: bedAllotmentEntity?.admission?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bedAllotment.home.createOrEditLabel" data-cy="BedAllotmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bedAllotment.home.createOrEditLabel">Create or edit a BedAllotment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bed-allotment-id"
                  label={translate('tinyMedicRestApp.bedAllotment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.allotmentDate')}
                id="bed-allotment-allotmentDate"
                name="allotmentDate"
                data-cy="allotmentDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.releaseDate')}
                id="bed-allotment-releaseDate"
                name="releaseDate"
                data-cy="releaseDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.lastupdated')}
                id="bed-allotment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.cursor')}
                id="bed-allotment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.active')}
                id="bed-allotment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.allotmentNotes')}
                id="bed-allotment-allotmentNotes"
                name="allotmentNotes"
                data-cy="allotmentNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.allotmentType')}
                id="bed-allotment-allotmentType"
                name="allotmentType"
                data-cy="allotmentType"
                type="select"
              >
                {bedAllotmentTypeValues.map(bedAllotmentType => (
                  <option value={bedAllotmentType} key={bedAllotmentType}>
                    {translate(`tinyMedicRestApp.BedAllotmentType.${bedAllotmentType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bedAllotment.releaseType')}
                id="bed-allotment-releaseType"
                name="releaseType"
                data-cy="releaseType"
                type="select"
              >
                {bedReleaseTypeValues.map(bedReleaseType => (
                  <option value={bedReleaseType} key={bedReleaseType}>
                    {translate(`tinyMedicRestApp.BedReleaseType.${bedReleaseType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="bed-allotment-bed"
                name="bed"
                data-cy="bed"
                label={translate('tinyMedicRestApp.bedAllotment.bed')}
                type="select"
                required
              >
                <option value="" key="0" />
                {beds
                  ? beds.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="bed-allotment-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.bedAllotment.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bed-allotment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BedAllotmentUpdate;
